export default {
  items: [
    {
      label: 'Live GeoGrids',
      href: '/geogrids',
      icon: 'fa-regular fa-border-outer',
      activeUrl: '/geogrids'
    },
    {
      label: 'Scheduled GeoGrids',
      href: '/scheduled_geogrids',
      icon: 'fa-regular fa-clock',
      activeUrl: '/scheduled_geogrids'
    },
    {
      label: 'Keyword Groups',
      href: '/keyword_groups',
      icon: 'fa-regular fa-layer-group',
      activeUrl: '/keyword_groups'
    },
    {
      label: 'GeoGrid Widgets',
      href: '/geogrid_widgets',
      icon: 'fa-regular fa-code',
      activeUrl: '/geogrid_widgets',
      show: (store) => {
        const { user, organization } = store
        if (!user.adminPrivileges) return false

        if (organization.isLinda) return organization.allowGgWidgetForLinda

        return organization.proPlanSubscriber
      }
    },
    {
      label: 'Tags statistic',
      href: '/scheduled_geogrids/tags_statistic',
      icon: 'fa-regular fa-tags',
      activeUrl: '/scheduled_geogrids/tags_statistic'
    }
  ]
}
